import { useState } from 'react';

import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import XIcon from '@/shared-components/icons/components/public/XIcon';
import GenericPopup from '@/shared-components/popups/components/GenericPopup';
import Text from '@/shared-components/text/components/Text';

import './ArtlistConfirmationDialog.css';

export default function ArtlistConfirmationDialog({ 
  open, 
  close, 
  onConfirmSaveAndExit,
  onConfirmCancel,
  canSave, 
  artlist, 
}) {
  const [saving, setSaving] = useState(false);

  const hasChanges = artlist && Object.keys(artlist).length > 0;

  const handleSaveAndExit = async () => {
    if (!hasChanges) {
      close();
      return;
    }
    setSaving(true);
    await onConfirmSaveAndExit();
  };

  return (
    <GenericPopup 
      className="generic-popup__card artlist-confirmation-dialog remove-scrollbar" 
      open={open} 
      opacity
    >
      <div className="artlist-confirmation-dialog__header">
        <Text className="artlist-confirmation-dialog__header-text" paragraph medium>
          Exit without saving?
        </Text>
        <XIcon 
          className="artlist-confirmation-dialog__close" 
          onClick={close} 
        />
      </div>

      <div className="artlist-confirmation-dialog__body">
        <Text className="artlist-confirmation-dialog__body-text" paragraph medium>
          If you exit now your changes will be lost
        </Text>
      </div>

      <div className="artlist-confirmation-dialog__action-buttons element-non-selectable">
        <ContinueButton 
          className="artlist-confirmation-dialog__button cancel continue-button_two"
          onClick={onConfirmCancel}
        >
          Yes, exit
        </ContinueButton>

        <ContinueButton 
          loading={saving}
          className="artlist-confirmation-dialog__button confirm continue-button_two"
          onClick={handleSaveAndExit}
          turnOff={!canSave}
        >
          Save and exit
        </ContinueButton>
      </div>
    </GenericPopup>
  );
}
